module.exports = __webpack_public_path__ + "img/SG.1561fd04.png";